import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const useProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${BACKEND_URL}/api/products`);
        setProducts(response.data);
        setError(null);
      } catch (err) {
        console.error('Error fetching products from API:', err);
        setError(err);
        // Fallback to mock data if API fails
        try {
          const { products: mockProducts } = await import('../mockData');
          setProducts(mockProducts);
        } catch (mockErr) {
          console.error('Error loading mock data:', mockErr);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  return { products, loading, error, refetch: () => {} };
};

export default useProducts;
